<template>
  <div v-if="savedSearch" class="query-text-wrap">
    Saved Search for {{ assignToClient.name }} -- <span>{{ savedSearch }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isEmpty } from '../../../../utils/generalUtils'
import {
  getFieldName,
  getCustomFieldValue
} from '../../../../services/autoSearchService'

export default {
  props: {
    assignToClient: {
      type: Object,
      required: true
    }
  },

  data: () => ({ savedSearch: '' }),

  computed: {
    ...mapState('common', ['searchObject']),
    ...mapState('agent', ['agentData'])
  },

  watch: {
    assignToClient: {
      handler: function(value) {
        if (!isEmpty(value) && value.autosearch && value.autosearch.length) {
          this.getCurrentSearch(value.autosearch[0])
        } else if (isEmpty(value)) {
          this.savedSearch = ''
        }
      }
    }
  },

  mounted() {
    if (
      !isEmpty(this.assignToClient) &&
      this.assignToClient.autosearch.length
    ) {
      this.getCurrentSearch(this.assignToClient.autosearch[0])
    } else if (isEmpty(this.assignToClient)) {
      this.savedSearch = ''
    }
  },

  methods: {
    getCurrentSearch(data) {
      const { query } = data
      const savedSearch = Object.entries(query).reduce(
        (savedSearch, [key, value]) => {
          if (!isEmpty(value)) {
            savedSearch += this.getArrayText(key, value)
          }
          return savedSearch
        },
        ''
      )

      this.savedSearch = savedSearch
    },

    getArrayText(key, value) {
      let updatedSavedText = `${getFieldName(key)}: `
      if (typeof value === 'object') {
        value.forEach(item => {
          updatedSavedText += `${item}, `
        })
        updatedSavedText = updatedSavedText.trim().slice(0, -1) + ' / '
      } else {
        updatedSavedText +=
          getCustomFieldValue(key, value, this.searchObject.searchType) + ' / '
      }
      return updatedSavedText
    }
  }
}
</script>

<style lang="sass" scoped>
.query-text-wrap
  padding: 1rem
  margin-left: -1rem
  margin-right: -1rem
  font-size: 1.2rem
  background: $hwayzWhite
  span
    color: $hwayzKellyGreen
</style>
